import {
  PT_REGISTER,
  PT_PROFILE,
  PT_OTP,
} from "../../routes/stack/paths/pt-profile";
import { PT_PRODUCT_LIST } from "../../routes/stack/paths/pt-home";
import {
  SET_STORE_TEMP_STORE_PHONE_NO,
  SET_STORE_STARTING_NO,
} from "../../database/store-data";
import {
  api_CheckMobilePhoneNumber,
  api_SendOtp,
} from "../../connection/api/api-profile";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import {
  ENTRY_MODE,
  MID,
  STORE_MERCHANT,
  STORE_SelectedMerchantProduct,
  TEMP_STORE_CSID,
} from "../../database/store-names";
import { GET_SET_STORED_DATA } from "../../database/get-stored-data";
import { ENCRYPT_STORAGE } from "../../config/config";
import { ToastMessage } from "../../components/toast-notification/toast";
import { dto_common } from "../../classes/dto-common";
import { dto_Merchant } from "../../classes/dto-merchant";
import { Colors } from "../../util/colors";
import { Font } from "../../util/config-fonts";
import FlagMV from "../../components/render-drawer-country/flagMV.png";
import FlagSL from "../../components/render-drawer-country/flagSL.png";
import React from "react";
import "../../styles/css/pg-profile-signin.css";
import "../../styles/css/common-btn.css";

export default class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logourl: "",
      logosrc: "",
      useMerchantImage: false,
      startingNo: "",
      isLoading: false,
      ContentLoading: true,
    };
  }

  resolveQrMerchantImage = () => {
    const currentMid = Number(ENCRYPT_STORAGE.getItem(MID));
    const storedSelectedMerchant =
      ENCRYPT_STORAGE.getItem(STORE_SelectedMerchantProduct) || {};
    const storedMerchants = ENCRYPT_STORAGE.getItem(STORE_MERCHANT);
    const storedMerchant =
      Array.isArray(storedMerchants) && storedMerchants.length > 0
        ? storedMerchants.find((merchant) => Number(merchant?.MID) === currentMid) ||
          storedMerchants[0]
        : storedMerchants || {};

    const imageCandidates = [
      dto_Merchant.ImageURL,
      storedSelectedMerchant.ImageURL,
      storedSelectedMerchant.IL,
      storedMerchant.ImageURL,
      storedMerchant.IL,
    ];

    return (
      imageCandidates.find(
        (imageUrl) => typeof imageUrl === "string" && imageUrl.trim() !== "",
      ) || ""
    );
  };

  async componentDidMount() {
    this.setState({ ContentLoading: true });
    await GET_SET_STORED_DATA();
    let CSP = dto_common.CSP;
    let natvieCountry = dto_common.NatvieCountry;
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);

    if (CSP === "AV") {
      this.setState({
        logosrc: require("./images/AvasLogo.png"),
      });
    } else if (CSP === "MK") {
      this.setState({
        logosrc: require("./images/MkbLogo.png"),
      });
    } else if (CSP === "DT") {
      const merchantImage =
        entryMode === "QR"
          ? this.resolveQrMerchantImage()
          : dto_Merchant.ImageURL;
      this.setState({
        logosrc:
          entryMode === "QR" && merchantImage
            ? merchantImage
            : require("./images/DaitonnLogo.png"),
        useMerchantImage: entryMode === "QR" && merchantImage.trim() !== "",
      });
    }

    if (natvieCountry === "LK") {
      this.setState({
        logourl: FlagSL,
        startingNo: "+" + dto_StartupPageLoadInfo.CountryPhoneCode,
      });
    } else if (natvieCountry === "MV") {
      this.setState({
        logourl: FlagMV,
        startingNo: "+" + dto_StartupPageLoadInfo.CountryPhoneCode,
      });
    }

    this.setState({ ContentLoading: false }, () => {
      setTimeout(() => {
        const phoneInput = document.getElementById("phoneno");
        if (phoneInput) {
          phoneInput.focus();
        }
      }, 0);
    });
  }

  async CheckPhone() {
    this.setState({ isLoading: true });
    const phoneno = document.getElementById("phoneno").value;
    const requiredPhoneLength = this.getRequiredPhoneLength();

    if (phoneno.length === requiredPhoneLength) {
      let CustomerMobileNumber =
        this.state.startingNo.replace("+", "") +
        document.getElementById("phoneno").value;
      let data = await api_CheckMobilePhoneNumber(CustomerMobileNumber);
      let objData = JSON.parse(data);
      let AppendData = JSON.parse(objData);
      if (AppendData[0][0].CSID > 0) {
        SET_STORE_STARTING_NO(this.state.startingNo);
        ENCRYPT_STORAGE.setItem(TEMP_STORE_CSID, AppendData[0][0].CSID);
        await api_SendOtp(CustomerMobileNumber);
        this.setState({ isLoading: false });
        this.props.navigate(PT_OTP);
      } else {
        this.props.navigate(PT_REGISTER);
      }
    } else {
      await ToastMessage(3, "Invlid Phone no");
      this.setState({ isLoading: false });
    }
  }

  sanitizePhoneNumber(value) {
    const digitsOnly = String(value || "").replace(/[^0-9]/g, "");
    return digitsOnly.replace(/^0+/, "");
  }

  getRequiredPhoneLength() {
    if (dto_common.CSP === "AV") {
      return 7;
    }

    if (dto_common.CSP === "DT" || dto_common.CSP === "MK") {
      return 9;
    }

    return parseInt(dto_StartupPageLoadInfo.CountryPhoneLength, 10);
  }

  render() {
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    const requiredPhoneLength = this.getRequiredPhoneLength();

    return (
      <div
        className="profileLayout "
        style={{
          height: "100vh",
        }}
      >
        <div
          className="pgProfileLogo"
          style={{ backgroundColor: Colors.ThemeBGcolor }}
        >
          {this.state.ContentLoading ? (
            ""
          ) : (
            <img
              alt="logo"
              src={this.state.logosrc}
              style={
                this.state.useMerchantImage
                  ? {
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: 4,
                    }
                  : undefined
              }
            />
          )}
        </div>
        <div
          style={{
            alignItems: "center",
            position: "fixed",
            top: 20,
            cursor: "pointer",
            fontSize: "18px",
          }}
          onClick={() => {
            if (entryMode === "QR") {
              const mid = ENCRYPT_STORAGE.getItem(MID);
              this.props.navigate(
                PT_PRODUCT_LIST.replace(":navPage", "none").replace(
                  ":isSec",
                  `MID=${mid}`,
                ),
              );
              return;
            }

            this.props.navigate(PT_PROFILE);
          }}
        >
          {" "}
          <i className="fa fa-arrow-left" aria-hidden="true" />
        </div>
        <div>
          <p style={{ font: Font.MainHeading }}>Enter your mobile number</p>
        </div>
        <div className="profileSignNum">
          <button
            style={{
              width: "60px",
              height: "50px",
              fontSize: Font.Heading,
              border: "none",
              cursor: "pointer",
              backgroundColor: "#f5f5f5",
            }}
          >
            <div style={{ display: "flex" }}>
              {this.state.ContentLoading ? (
                ""
              ) : (
                <img
                  src={this.state.logourl}
                  alt="logo"
                  width="80%"
                  style={{ marginTop: 3 }}
                />
              )}
            </div>
          </button>
          <div style={{ display: "flex" }}>
            <p
              style={{
                backgroundColor: "#f5f5f5",
                height: 50,
                margin: 0,
                marginLeft: 5,
                paddingTop: 18,
                paddingLeft: 15,
                fontSize: Font.Heading,
              }}
            >
              {this.state.startingNo}
            </p>
            <input
              className="profileSignInput"
              style={{
                fontSize: Font.Heading,
                border: "none",
                marginRight: 10,
              }}
              autoFocus
              onChange={(e) => {
                e.currentTarget.value = this.sanitizePhoneNumber(
                  e.currentTarget.value,
                );
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  document.getElementById("CheckPhoneBTN").click();
                }
              }}
              id="phoneno"
              name="phoneNumber"
              type="tel"
              pattern="[0-9]*"
              minLength={requiredPhoneLength}
              maxLength={requiredPhoneLength}
              placeholder="Phone number"
              autoComplete="tel"
            />
          </div>
          {!this.state.isLoading ? (
            <button
              id="CheckPhoneBTN"
              style={{
                justifyContent: "center",
                justifyItems: "center",
                backgroundColor: Colors.DarkGreyScale,
                height: 48,
                width: 48,
                color: "white",
                fontSize: Font.MainHeading,
                border: "none",
                borderRadius: 3,
                cursor: "pointer",
              }}
              onClick={async () => {
                SET_STORE_TEMP_STORE_PHONE_NO(
                  this.state.startingNo.replace("+", "") +
                    document.getElementById("phoneno").value,
                );
                this.CheckPhone();
              }}
            >
              <i className="fa fa-arrow-right" aria-hidden="true" />
            </button>
          ) : (
            <button
              style={{
                justifyContent: "center",
                justifyItems: "center",
                backgroundColor: Colors.DarkGreyScale,
                height: 48,
                width: 48,
                color: "white",
                fontSize: Font.MainHeading,
                border: "none",
                borderRadius: 3,
                cursor: "pointer",
              }}
            >
              <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true" />
            </button>
          )}
        </div>
      </div>
    );
  }
}
